/**
 * Centralized enums file to maintain consistency across the application
 */

// Service request status
export enum ServiceRequestStatus {
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected'
}

// Task status from task.ts, now centralized
export enum TaskStatus {
  TODO = 'todo',
  OPEN = 'open',
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  DONE = 'done',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled'
}

// Task priority 
export enum TaskPriority {
  LOW = 'low',
  MEDIUM = 'medium', 
  HIGH = 'high'
}

// Property types
export enum PropertyType {
  RESIDENTIAL = 'residential',
  COMMERCIAL = 'commercial',
  INDUSTRIAL = 'industrial'
}

// Contract status
export enum ContractStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  PENDING_RENEWAL = 'pending_renewal'
}

// Contract document status
export enum ContractDocumentStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected'
}

// Contract proposal status
export enum ContractProposalStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected'
}

// Term unit for contracts
export enum TermUnit {
  MONTH = 'month',
  YEAR = 'year',
  DAY = 'day'
}

// Payment status
export enum PaymentStatus {
  SUCCEEDED = 'succeeded',
  PENDING = 'pending',
  FAILED = 'failed'
}

// Billing interval
export enum BillingInterval {
  MONTH = 'month',
  YEAR = 'year'
}

// Invoice status
export enum InvoiceStatus {
  DRAFT = 'draft',
  SENT = 'sent',
  PAID = 'paid',
  VOID = 'void'
}

// Active status for general use
export enum ActiveStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

// Draft status for content
export enum DraftStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived'
}

// Helper status
export enum HelperStatus {
  AVAILABLE = 'available',
  ON_TASK = 'on_task',
  OFFLINE = 'offline'
}

// User roles, moved from auth.ts
export enum UserRole {
  ADMIN = 'admin',
  PROPERTY_OWNER = 'property_owner',
  PROPERTY_MANAGER = 'property_manager',
  FLEX_HELPER = 'flex_helper'
}

// Chat message types
export enum ChatMessageType {
  TEXT = 'text',
  IMAGE = 'image',
  FILE = 'file',
  SYSTEM = 'system'
}

// Chat message status
export enum ChatMessageStatus {
  SENT = 'sent',
  DELIVERED = 'delivered',
  READ = 'read',
  FAILED = 'failed'
}

// Chat conversation types
export enum ChatConversationType {
  DIRECT = 'direct',
  GROUP = 'group'
}

// Chat group types
export enum ChatGroupType {
  TASK = 'task',
  PROPERTY = 'property',
  TEAM = 'team'
}

// Chat participant status
export enum ChatParticipantStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
  AWAY = 'away',
  BUSY = 'busy'
}

// Notification types
export enum NotificationType {
  TASK = 'task',
  CHAT = 'chat',
  SYSTEM = 'system',
  CONTRACT = 'contract',
  PAYMENT = 'payment'
}

// Notification priority
export enum NotificationPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}